import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import Innerhtml from "../utils/Innerhtml";
import Link from "next/link";

const HeroSection = ({ data }) => {
  const rawSlides = data?.advanceData?.data?.slides;
  const slides = Array.isArray(rawSlides) ? rawSlides : [];

  return (
    <section className="pt-6 pb-4">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="w-full mb-4">
          <Swiper
            spaceBetween={20}
            centeredSlides
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            navigation={false}
            modules={[Autoplay, Pagination, Navigation]}
            className="homeHeroSwiper rounded-2xl overflow-hidden"
          >
            {slides.map((item, index) => (
              <SwiperSlide key={index}>
                <Link href={item?.href || "#"} className="block">
                  <div className="relative aspect-[16/6] w-full overflow-hidden rounded-[16px] sm:rounded-[18px] bg-gray-100">
                    <img
                      src={item?.imgUrl}
                      alt={`Hero banner ${index + 1}`}
                      className="h-full w-full object-cover"
                      fetchPriority={index === 0 ? "high" : "auto"}
                      loading={index === 0 ? "eager" : "lazy"}
                      decoding="async"
                    />
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-gray-800">
            {data?.heading}
          </h1>

          <h2 className="mt-3 text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-bold leading-tight text-[#314823]">
            {data?.subHeading}
          </h2>

          <div className="mt-6 text-base md:text-lg leading-8 max-w-3xl mx-auto text-gray-700">
            <Innerhtml data={data?.content} />
          </div>

          {Array.isArray(data?.buttons) && data.buttons.length > 0 && (
            <div className="mt-8 flex flex-wrap justify-center gap-4">
              {data.buttons.map((item, ind) => (
                <Link
                  key={ind}
                  href={item.link}
                  className={`px-8 py-3 rounded-full font-semibold transition-all duration-300 ${
                    ind === 0
                      ? "bg-[#314823] text-white hover:opacity-90"
                      : "border border-[#f1bb62] text-[#334821] hover:bg-[#f1bb62] hover:text-white"
                  }`}
                >
                  {item.title} →
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
